export const jobEntries = {
  en: {
    title: "Work experience",
    entries: [
      {
        title: "Senior Software Developer",
        company: "Qubika",
        date: "2022/08 - ",
        description:
          "Software consultancy (remote). I worked for two different clients under the same employer. I also run backend (Python: Django/FastAPI) technical interviews to assess candidates for specific roles and clients.",
        projects: [
          {
            title:
              "Current client — B2B SaaS for student loans & corporate benefits (2024 - present)",
            description:
              "Django + Next.js, team of 5 developers. I led the migration from Next.js 12 (Page Router) to Next.js 14 (App Router) and optimized a key process from 30+ seconds to under 2 seconds. I integrated the product directly with DocuSign, removing a middle service and its dependencies; refactored front-end components using the Higher-Order Components (HOC) pattern; and improved the CI/CD pipeline (pinpointing the failing test, parallelizing the test suite and a smoother hotfix flow). I acted as release manager on a critical release, coordinating hotfixes across several teams.",
          },
          {
            title: "Previous client — Consumer-lending fintech (2022 - 2023)",
            description:
              "I took over a highly complex legacy system (heavy metaprogramming, no documentation, impossible to run locally) and became the team's reference on its architecture. I led the integration of external credit-scoring services and worked across multiple repos, front and back, driving improvements in engineering practices.",
          },
        ],
      },
      {
        title: "Conversational sales assistant (AI SaaS)",
        company: "Personal project (in production)",
        date: "2026 - ",
        description:
          "Multitenant SaaS that answers FAQs, builds orders (creates Shopify draft orders and hands off payment) and handles post-sale support. Channel-agnostic (web, WhatsApp, Instagram) and commerce-platform-agnostic. Running in production on GCP with a first real client onboarded.",
        projects: [
          {
            title: "Architecture",
            description:
              "Three-service monorepo: a Rails 8 API-only backend (multitenancy, Sidekiq, Postgres + pgvector) as the source of truth; a Python + FastAPI + LangChain/LangGraph AI service orchestrating Claude (RAG, tool use, memory, guardrails); and a Next.js + React + TypeScript frontend (embeddable widget, operator inbox, admin). Cross-service contract versioned in OpenAPI.",
          },
          {
            title: "LLM security & cost control",
            description:
              "Cross-tenant containment, data-vs-instructions separation and red-team evals. I instrumented per-token cost per message and per tenant, found that prompt caching wasn't kicking in (the cacheable prefix fell below the model's minimum, silently ignored by the API) and resized the global prompt to enable it.",
          },
        ],
      },
      {
        title: "Insurance quoting platform (workers' comp)",
        company: "Freelance — Promecor",
        date: "2025/11 - ",
        description:
          "A system that automates quoting, re-quoting and reconciliation for workers'-compensation insurance, integrated with Zoho CRM and with insurers' online portals.",
        projects: [
          {
            title: "Quote Gateway (Rails 8 API-only)",
            description:
              "Orchestrates quotes and re-quotes (Sidekiq + Redis, PostgreSQL with UUID PKs), integrates with Zoho CRM (COQL) and includes a reconciliation engine with per-insurer normalizers and a declarative catalog of checks.",
          },
          {
            title: "Insurer scraper (FastAPI + Playwright)",
            description:
              "Automates insurer portals that have no API (Template Method + registry pattern), integrated asynchronously via webhook with Rails and deployed on GCP Cloud Run. Reconciliation front-end built in Next.js.",
          },
        ],
      },
      {
        title: "Full-stack web developer (React / RoR) & Co-Founder",
        company: "Oyga",
        date: "2016/03 - 2022/07",
        description:
          "As a founder and developer at Oyga (a digital agency), I was in charge of all the development projects. (The first ~1.5 years ran in parallel with my role at Avature.)",
        projects: [
          {
            title: "Oyga APP",
            description:
              "We unified Google Ads and Facebook Ads to keep all paid-ad data in a single place: real-time dashboards with key metrics, custom reports and alerts. Front-end in React with a design system in Storybook; backend a REST API in RoR. I worked on both front and back.",
          },
          {
            title: "Payment gateway integration",
            description:
              "A payment-processing app in RoR, integrated with MercadoPago and Decidir, improving the payment experience while reducing processing costs. I was the main developer.",
          },
          {
            title: "QR code CMS",
            description:
              "A system to manage QR codes, letting the client create QR with custom styles and add logic (login page, custom forms) before the final redirect. Built entirely in RoR as the main developer.",
          },
          {
            title: "Inventory integration",
            description:
              "A real-time sync between the client's WMS and their e-commerce stores (Shopify and VTEX). I owned the project and, as a developer, implemented the authentication and authorization.",
          },
        ],
      },
      {
        title: "QA Automation Specialist",
        company: "Avature",
        date: "2016/08 - 2017/12",
        description:
          "As a QA automation specialist I implemented unit and integration tests, and improved the test framework to cover previously unsupported scenarios.",
        projects: [],
      },
      {
        title: "Product & Operations",
        company: "MercadoPago",
        date: "2011/08 - 2016/06",
        description:
          "I grew from Operations Assistant to Operations Analyst and then to Ssr Product Analyst. As a PO, I worked to increase MercadoPago's adoption on third-party sites, working closely with sellers and their developers to solve their pain points. Main projects:",
        projects: [
          { title: "Open platform" },
          { title: "Developer site" },
          { title: "MercadoEnvíos integration" },
          { title: "New payment experience (Desktop, Web Mobile, native SDKs)" },
          { title: "Reconciliation tools" },
        ],
      },
    ],
  },
  es: {
    title: "Experiencia laboral",
    entries: [
      {
        title: "Senior Software Developer",
        company: "Qubika",
        date: "2022/08 - ",
        description:
          "Consultora de software (remoto). Trabajé para dos clientes distintos dentro del mismo empleador. Además tomo entrevistas técnicas de backend (Python: Django/FastAPI) para evaluar la aptitud de candidatos según la posición y el cliente.",
        projects: [
          {
            title:
              "Cliente actual — SaaS B2B de préstamos estudiantiles y beneficios corporativos (2024 - presente)",
            description:
              "Django + Next.js, equipo de 5 developers. Lideré la migración de Next.js 12 (Page Router) a Next.js 14 (App Router) y optimicé un proceso clave que pasó de más de 30 s a menos de 2 s. Integré el producto directamente con DocuSign, eliminando un servicio intermedio y sus dependencias; refactoricé componentes del front con el patrón Higher-Order Components (HOC); y mejoré el pipeline de CI/CD (identificación del test que falla, paralelización de la suite y un flujo de hotfix más ágil). Actué como release manager de una versión crítica, coordinando los hotfixes con distintos equipos.",
          },
          {
            title: "Cliente anterior — Fintech de préstamos al consumo (2022 - 2023)",
            description:
              "Tomé control de un sistema legacy extremadamente complejo (metaprogramación intensa, sin documentación, imposible de correr localmente) y me convertí en el referente del equipo sobre su arquitectura. Lideré la integración de servicios externos de evaluación crediticia y trabajé en múltiples repos, front y back, impulsando mejoras en las prácticas de ingeniería.",
          },
        ],
      },
      {
        title: "Asistente de ventas conversacional (SaaS con IA)",
        company: "Proyecto propio (en producción)",
        date: "2026 - ",
        description:
          "SaaS multitenant que responde FAQs, arma pedidos (crea draft orders en Shopify y deriva el pago) y da soporte post-venta. Agnóstico de canal (web, WhatsApp, Instagram) y de plataforma de comercio. Corriendo en producción en GCP con un primer cliente real onboardeado.",
        projects: [
          {
            title: "Arquitectura",
            description:
              "Monorepo de tres servicios: backend Rails 8 API-only (multitenancy, Sidekiq, Postgres + pgvector) como fuente de verdad; servicio de IA en Python + FastAPI + LangChain/LangGraph orquestando Claude (RAG, tool use, memoria, guardarraíles); y frontend Next.js + React + TypeScript (widget embebible, inbox de operador, admin). Contrato entre servicios versionado en OpenAPI.",
          },
          {
            title: "Seguridad y costos de LLM",
            description:
              "Contención cross-tenant, separación datos-vs-instrucciones y evals red-team. Instrumenté el costo por token por mensaje y por tenant, detecté que el prompt caching no se activaba (el prefijo cacheable quedaba por debajo del mínimo del modelo, ignorado en silencio por la API) y redimensioné el prompt global para activarlo.",
          },
        ],
      },
      {
        title: "Plataforma de cotización de seguros (ART)",
        company: "Freelance — Promecor",
        date: "2025/11 - ",
        description:
          "Sistema que automatiza cotizaciones, re-cotizaciones y conciliación de seguros de riesgo del trabajo, integrado con Zoho CRM y con los portales online de las aseguradoras.",
        projects: [
          {
            title: "Quote Gateway (Rails 8 API-only)",
            description:
              "Orquesta cotizaciones y re-cotizaciones (Sidekiq + Redis, PostgreSQL con PKs UUID), integra con Zoho CRM (COQL) e incluye un motor de conciliación con normalizadores por aseguradora y un catálogo declarativo de controles.",
          },
          {
            title: "Scraper de aseguradoras (FastAPI + Playwright)",
            description:
              "Automatiza portales de aseguradoras sin API (patrón Template Method + registry), integrado de forma asíncrona por webhook con Rails y desplegado en GCP Cloud Run. Front de conciliación construido en Next.js.",
          },
        ],
      },
      {
        title: "Full-stack web developer (React / RoR) & Co-Founder",
        company: "Oyga",
        date: "2016/03 - 2022/07",
        description:
          "Como fundador y desarrollador en Oyga (una agencia digital), estuve a cargo de todos los proyectos de desarrollo. (Los primeros ~1,5 años los llevé en paralelo con mi rol en Avature.)",
        projects: [
          {
            title: "Oyga APP",
            description:
              "Unificamos Google Ads y Facebook Ads para tener toda la información de la pauta digital en un solo lugar: paneles en tiempo real con las métricas clave, reportes customizables y alertas. Front-end en React con un design system en Storybook; backend una API REST en RoR. Trabajé tanto en el front como en el back.",
          },
          {
            title: "Integración de gateway de pagos",
            description:
              "App de procesamiento de pagos en RoR, integrada con MercadoPago y Decidir, que mejoraba la experiencia del usuario mientras bajaba los costos de procesamiento. Fui el desarrollador principal.",
          },
          {
            title: "CMS para códigos QR",
            description:
              "Un sistema para administrar códigos QR, permitiendo al cliente crearlos con estilos customizados y agregar lógica (página de login, formularios) antes de la redirección final. Desarrollado completamente en RoR como desarrollador principal.",
          },
          {
            title: "Integración de stock",
            description:
              "Sincronización en tiempo real entre el WMS del cliente y sus e-commerce (Shopify y VTEX). Estuve a cargo del proyecto y, como desarrollador, implementé la autenticación y la autorización.",
          },
        ],
      },
      {
        title: "QA Automation Specialist",
        company: "Avature",
        date: "2016/08 - 2017/12",
        description:
          "Como especialista en QA automation implementé tests unitarios y de integración, y mejoré el framework de testing para cubrir escenarios previamente no soportados.",
        projects: [],
      },
      {
        title: "Producto & Operaciones",
        company: "MercadoPago",
        date: "2011/08 - 2016/06",
        description:
          "Escalé de Asistente de Operaciones a Analista de Operaciones y luego a Analista Ssr de Producto. Como PO, trabajé para mejorar la penetración de MercadoPago en sitios de terceros, de cerca con los vendedores y sus desarrolladores para resolver sus problemas. Principales proyectos:",
        projects: [
          { title: "Open platform" },
          { title: "Sitio de desarrolladores" },
          { title: "Integración de MercadoEnvíos" },
          { title: "Nueva experiencia de pago (Desktop, Web Mobile, SDKs nativas)" },
          { title: "Herramientas de conciliación" },
        ],
      },
    ],
  },
};
